var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "popup-block pointer",
    on: {
      "click": _vm.selectFixation
    }
  }, [_c('div', {
    staticClass: "vertical-align-divs flex-row"
  }, [_c('div', {
    staticClass: "user-relation"
  }, [_vm.selected ? _c('div', [_c('img', {
    staticClass: "nav-link-icon filter-primary",
    attrs: {
      "src": "https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f25_icons8-check.svg",
      "alt": ""
    }
  })]) : _vm._e(), _c('div', {
    staticClass: "text-block"
  }, [_c('div', {
    staticClass: "text--black"
  }, [_vm._v(" " + _vm._s(_vm.year) + " " + _vm._s(_vm.title) + " ")])])])])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }